export default __webpack_public_path__ + "static/char-v-41-ja-5b2730cd66670ecfb632f04dcf55b2a4.mp4";